/** 认证邀请码POC用户校验读取状态 */
export const POST_INVITE_CODE_POC_READ = "/api/student/inviteCodePocRead"; 

// 认证邀请码POC用户验证码列表
export const POST_INVITE_CODE_POC_COUNT = "/api/student/inviteCodePocCount"; 

//认证邀请码POC用户下载表格
export const POST_INVITE_CODE_POC_DOWNLOAD = "/api/student/inviteCodePocDownload"; 


 